import { create } from "zustand";
import jwtDecode from 'jwt-decode';

import { callApi } from 'utils';
import { clearWorkspaceTabs } from './workspaceTabs';

// init auth token for revisited user
function decodeToken() {
  const token = localStorage.getItem('token');
  if (!token) {
    clearWorkspaceTabs();
    return null;
  }
  try {
    const decoded = jwtDecode(token);
    //console.log('jwt:', decoded);
    if (!decoded.exp || decoded.exp > Date.now() / 1000) {
      return decoded;
    }
  } catch (ex) {
    console.log(ex);
  }
  localStorage.removeItem('token');
  clearWorkspaceTabs();
  return null;
}

function getJwtData() {
  const data = decodeToken();
  return { session: data, loggedIn: !!data };
}

const loggedInListeners = [];

function notifyLoggedIn() {
  loggedInListeners.forEach(func => setTimeout(func, 0));
}

const useSession = create((set, get) => ({
  ...getJwtData(),
  tz: 'Asia/Shanghai',
  login: async (user) => {
    const { token } = await callApi('/users/login', 'POST', user, false);
    localStorage.setItem("token", token);
    clearWorkspaceTabs();
    set({ ...getJwtData() });
    notifyLoggedIn();
  },
  logout: () => {
    localStorage.removeItem("token");
    clearWorkspaceTabs();
    set({ session: null, loggedIn: false });
  },
  updateProfile: () => callApi('/users/profile').then((resp) => {
    const old = get();
    const same = Object.keys(resp).every((key) => resp[key] === old?.[key]);
    if (!same) {
      let tz = resp.tz;
      delete resp.tz;
      set((state) => ({ session: { ...state?.session, ...resp }, tz }))
    }
  }).catch(() => {
    clearWorkspaceTabs();
    set({ session: null, loggedIn: false });
  }),
}));

export function hookLoggedIn(func) {
  loggedInListeners.push(func);
  if (useSession.getState().loggedIn) {
    setTimeout(func, 0);
  }
}

// update profile if logged in
hookLoggedIn(() => useSession.getState().updateProfile());

export default useSession;
